const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoD(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 307.2 148.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M299,362.13s5.78-.44,4.85,1v8.08s7.46-5,11.2,2.89v3.65s-3.43,8.13-11,2.66v9.12s-9.44.57-19.44-8.16a34.68,34.68,0,0,1-9-18.87c.36.13,3.43-1.33,3,.94-.74,4.1,3.08,9.88,8.36,10.26a11.48,11.48,0,0,0,3.55,0s7.27-1.09,7.74-9.49C298.27,364.2,297.84,362.19,299,362.13Z",
    transform: "translate(-152 -321.78)",
    style: {
      fill: "#0157a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.13,342.47v-11.2s13.07.53,20.6,9.46,7.34,15.47,7.67,18c0,0-3.07,1.47-3.27-1s-1.2-8.33-8.13-9.73a10.38,10.38,0,0,0-4.93.2c-3.27.73-7,5.67-6.74,8.73,0,0,1.27,2.6-2.06,1.94H308s-1.07.13-.87-1.54,0-6.6,0-6.6-6.66,6.34-11.4-2.06a6.06,6.06,0,0,1,0-3.87C296.47,342.87,300.53,336.67,307.13,342.47Z",
    transform: "translate(-152 -321.78)",
    style: {
      fill: "#0157a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.69,331.51v5.16s-8.62-.94-11.36,7.06c0,0-2.82,12.4,11.36,12.4v2.74h-9.76s-1.8-.07-.2,1.2a8,8,0,0,1,.67,6.6c-1.33,3.4-8.47,6.33-11.73,0a6.8,6.8,0,0,1,1.2-7s2.66-1.27-4.74-.8H276.8s-1.87.66-.53-4.14,5.2-13.4,11.4-17.46S298.94,331.64,303.69,331.51Z",
    transform: "translate(-152 -321.78)",
    style: {
      fill: "#f04b51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.5,385.6v4.2s7-1.6,10.3-2.6,12-7.2,15.2-14.8c0,0,2.33-6.27,2.13-7.4l.27-1.8s.53-1.31-2.13-1l-5,0s-2.2.64-.27-2.16-.35-6.36-1.22-7.07-3.2-2.78-7.56-1c0,0-2.88,1.47-3.4,4.13a8.12,8.12,0,0,0,1.2,5.27s1.07,1.11-2,.89l-7.57,0v4.22l3.07,0a9.56,9.56,0,0,1,6.4,4,9.25,9.25,0,0,1,1.4,8.33A10.61,10.61,0,0,1,307.5,385.6Z",
    transform: "translate(-152 -321.78)",
    style: {
      fill: "#f04b51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,394.19V393L306.6,396l-5.51,3.4-.06-2s-14.12-.35-25.24-14.61a39.21,39.21,0,0,1-7.12-20H272S272.24,388.91,301,394.19Z",
    transform: "translate(-152 -321.78)",
    style: {
      fill: "#f04b51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,356.93h1.4l-3.26,5.74-3.4-5.74h2.06a38.61,38.61,0,0,1,3.53-12.71s5.28-10,13.15-14.75,11.73-5.29,18.18-6.05v3.47a28.4,28.4,0,0,0-12.85,3.29c-6.71,3.51-9.73,7.29-9.73,7.29s-5.11,5.77-6,8.89C275.11,346.36,273.27,348.6,272,356.93Z",
    transform: "translate(-152 -321.78)",
    style: {
      fill: "#0157a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.49,326.89v1.47L305,325.2l5.51-3.42v2a38.52,38.52,0,0,1,16.75,6.45,35.35,35.35,0,0,1,11.34,13.06,34.65,34.65,0,0,1,4.31,15h-3.2a33.23,33.23,0,0,0-5-15.38c-4.67-7-9-9.82-9.95-10.31S321.42,329.24,310.49,326.89Z",
    transform: "translate(-152 -321.78)",
    style: {
      fill: "#f04b51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.63,364.47h1.67L341,358.73l-3.2,5.74h1.86s-2.36,26.33-31.56,30.06v3.34a36.28,36.28,0,0,0,25.2-12.14S342.07,375.33,342.63,364.47Z",
    transform: "translate(-152 -321.78)",
    style: {
      fill: "#0455a2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.64 95.69 0 95.69 0 90.13 29.07 90.13 29.07 95.69 17.16 95.69 17.16 121.33 11.78 121.33 11.64 95.69",
    style: {
      fill: "#f04b51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.31 90.13 38.13 90.13 38.04 121.33 32.31 121.33 32.31 90.13",
    style: {
      fill: "#f04b51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.42 90.13 62.98 90.13 62.98 121.47 57.42 121.47 57.42 107.91 41.87 107.91 41.87 103.02 57.42 103.02 57.42 90.13",
    style: {
      fill: "#f04c52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.04 90.13 96.04 95.78 73.82 95.78 73.82 115.78 96.04 115.78 96.04 121.47 68.27 121.47 68.27 90.13 96.04 90.13",
    style: {
      fill: "#f04b51"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.64,
    y: 103.29,
    width: 17.2,
    height: 4.53,
    style: {
      fill: "#ee4c52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.42 90.13 111.42 95.78 123.16 95.78 123.24 121.47 128.49 121.47 128.49 95.73 140.36 95.73 140.36 90.13 111.42 90.13",
    style: {
      fill: "#f04b51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.91,443.24h6.4l13.91-23.86,6.85,11.38H305.6L303,435.24h14.71l4.71,8h6.76l-18-29.71s-2.33-4.4-5.6,0Z",
    transform: "translate(-152 -321.78)",
    style: {
      fill: "#f04b51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.27 90.16 185.73 90.16 185.73 115.89 206.6 115.89 206.6 121.47 180.27 121.47 180.27 90.16",
    style: {
      fill: "#f04a51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.33 90.16 238.27 90.16 238.27 95.82 215.93 95.82 215.93 115.76 238.27 115.76 238.27 121.47 210.33 121.47 210.33 90.16",
    style: {
      fill: "#f04b51"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.73,
    y: 103.22,
    width: 17.33,
    height: 4.67,
    style: {
      fill: "#f04b51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.53,411.6H427v28.93s-1.13,6.67-7.13,0l-20-20.13v22.84h-5.2V414.07s1.33-4.34,5.2-1.4l21.6,21.53Z",
    transform: "translate(-152 -321.78)",
    style: {
      fill: "#f04b51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.13 90.22 307.2 90.22 307.2 95.76 295.53 95.76 295.4 121.72 289.87 121.72 289.87 95.62 278.13 95.62 278.13 90.22",
    style: {
      fill: "#f04b51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.24 138.47 68.67 138.49 68.67 140.16 0.24 140.16 0.24 138.47",
    style: {
      fill: "#0056a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.59 138.56 307.01 138.58 307.01 140.25 238.59 140.25 238.59 138.56",
    style: {
      fill: "#0056a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.31 148.22 75.42 148.22 77.38 143.96 84.27 143.96 86.22 148.22 89.33 148.22 80.82 130.04 72.31 148.22",
    style: {
      fill: "#0056a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.85 135.82 78.61 141.42 83.15 141.51 80.85 135.82",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.49,456.89V454a6.81,6.81,0,0,0-4-1.73s-3.69-.53-6,.93a9.61,9.61,0,0,0-4.85,6.72s-.44,4.44,1.52,6.8a9.94,9.94,0,0,0,5.88,3.8,10.39,10.39,0,0,0,7.45-1.54v-3.29a11.88,11.88,0,0,1-4.18,2,6.12,6.12,0,0,1-7.6-5,7.66,7.66,0,0,1,.85-4.75C246.84,456,250.31,452.8,256.49,456.89Z",
    transform: "translate(-152 -321.78)",
    style: {
      fill: "#0157a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.91,456.89V454a6.76,6.76,0,0,0-4-1.73s-3.69-.53-6,.93a9.58,9.58,0,0,0-4.84,6.72s-.45,4.44,1.51,6.8a9.93,9.93,0,0,0,5.89,3.8,10.37,10.37,0,0,0,7.44-1.54v-3.29a11.88,11.88,0,0,1-4.18,2,6.13,6.13,0,0,1-7.6-5A7.66,7.66,0,0,1,263,458C264.27,456,267.73,452.8,273.91,456.89Z",
    transform: "translate(-152 -321.78)",
    style: {
      fill: "#0157a4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.24 130.8 135.11 130.8 135.11 133.47 128.22 133.47 128.27 137.64 135.11 137.64 135.11 140.13 128.27 140.13 128.22 145.78 135.11 145.78 135.11 148.31 125.24 148.31 125.24 130.8",
    style: {
      fill: "#0656a2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.56 130.94 159.42 130.94 159.42 133.6 152.53 133.6 152.58 137.78 159.42 137.78 159.42 140.27 152.58 140.27 152.53 145.92 159.42 145.92 159.42 148.45 149.56 148.45 149.56 130.94",
    style: {
      fill: "#0656a2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.18 130.94 141.16 130.94 141.16 145.91 147.38 145.91 147.38 148.45 138.18 148.31 138.18 130.94",
    style: {
      fill: "#0656a2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.67,452.72h5.69s2.84-.23,4,3.15a7.71,7.71,0,0,1,0,3.46s-.05,2.27-3.65,2.89l5.38,7.29L334.18,452l8.58,18.27H339.6l-2-4.54H330.8l-2.09,4.54h-5.33l-6-7.92-.05,7.92h-2.66Z",
    transform: "translate(-152 -321.78)",
    style: {
      fill: "#0958a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.42,455.11v5.07a21.49,21.49,0,0,0,2.8-.31c.27-.17,1.11-.23,1.25-1.34S322.13,454.71,317.42,455.11Z",
    transform: "translate(-152 -321.78)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.11 135.98 179.87 141.58 184.4 141.67 182.11 135.98",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.43,455.2h-4.36v-2.73h12.2v2.73H348.6v15h-2.87v-14.8S345.63,454.93,345.43,455.2Z",
    transform: "translate(-152 -321.78)",
    style: {
      fill: "#0056a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.2,452.89s4.93-1.82,8.44.49,4.23,4.58,4.49,6.13a9.78,9.78,0,0,1-.53,5.6c-.84,1.6-1.6,3.88-6.71,5.45,0,0-3.82.55-6.58-1a10.16,10.16,0,0,1-4.67-6.72S352.36,456.36,359.2,452.89Z",
    transform: "translate(-152 -321.78)",
    style: {
      fill: "#0357a8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.91,
    cy: 139.62,
    rx: 6.42,
    ry: 6.56,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.38,452.58h6.09s3.46.8,3.95,3.69a5.06,5.06,0,0,1-1.55,5.16,8,8,0,0,1-2.31.88l6,7.78H384l-5.42-7.65s-.58-.66-.31.58v7.07h-2.93Z",
    transform: "translate(-152 -321.78)",
    style: {
      fill: "#0f55a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.31,455.07v5.27a21.91,21.91,0,0,0,2.92-.33c.28-.17,1.16-.23,1.3-1.38S383.23,454.66,378.31,455.07Z",
    transform: "translate(-152 -321.78)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoD);
export default __webpack_public_path__ + "static/media/logoD.621d879bae2ac34d1067f6c70ce299b4.svg";
export { ForwardRef as ReactComponent };